import React, { useEffect, useState } from 'react';
import { NumberEditor } from '@contentful/field-editor-number';
import { FieldExtensionSDK } from 'contentful-ui-extensions-sdk';
import { EntityList, EntityListItem } from '@contentful/forma-36-react-components';

interface FieldProps {
  sdk: FieldExtensionSDK;
}

interface SpaceX {
  [key: string]: any
}

let ENDPOINT = "https://api.spacexdata.com/v4/"
let flights: any[] = [];

// Fetch past flights from Unoffical SpaceX API
// onload of component
fetch(ENDPOINT + "launches/past")
    .then(res => res.json())
    .then(result => flights = result)

const Field = (props: FieldProps) => {

  let [results, updateResults] = useState([] as any)

  async function updateEntry(e: SpaceX) {
    let data: SpaceX = await fetch(ENDPOINT+"rockets/"+e.rocket)
    .then(res => res.json())
    .then(result => ({...e, rocket_name: result.name, rocket_type: result.type}));

    Object.values(props.sdk.entry.fields).forEach(y => {
      if(y.id in data && y.id !== "flight_number") {
        y.setValue(data[y.id])
      } else console.log(y)

    })

  }
 
  useEffect(() => {
    props.sdk.field.onValueChanged((elem) => {
      let tmp = flights.filter(f => f.flight_number.toString().includes(elem.toString()))
      updateResults((t: any )=> {
        return tmp.slice(0, 3)})
    })
    props.sdk.window.startAutoResizer()
  }, [props.sdk])

  // on click 
  return (
  <>
  <NumberEditor
    field={props.sdk.field} 
    isInitiallyDisabled={false} />
    <div id="results"  style={{marginTop: "20px"}}>
      <EntityList> 
      {results.map((e: any) => (<EntityListItem onClick={() => updateEntry({...e,mission_patch_url: e.links.patch.small, webcast_video_url: e.links.webcast })} thumbnailUrl={e.links.patch.small} title={e.flight_number + ". " + e.name}> </EntityListItem>))}
      </EntityList>
      
    </div>
    </>);
};

export default Field;
